import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';

const ServicesModal = ({ show, handleClose, mode, serviceData, onSave }) => {
  const [formData, setFormData] = useState({
    serviceName: '',
    serviceStatus: 'Active',
    onOffScreen: 'On',
    priority: 1,
    icon: 'bi bi-app'
  });

  useEffect(() => {
    if (mode === 'edit' && serviceData) {
      setFormData(serviceData);
    } else {
      setFormData({
        serviceName: '',
        serviceStatus: 'Active',
        onOffScreen: 'On',
        priority: 1,
        icon: 'bi bi-app'
      });
    }
  }, [mode, serviceData, show]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
    handleClose();
  };

  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          {mode === 'add' ? 'Add Service' : 'Edit Service'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Service Name <span className="text-danger">*</span></Form.Label>
                <Form.Control
                  type="text"
                  name="serviceName"
                  value={formData.serviceName}
                  onChange={handleChange}
                  placeholder="e.g., Mobile Recharge"
                  required
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Icon <span className="text-danger">*</span></Form.Label>
                <Form.Select
                  name="icon"
                  value={formData.icon}
                  onChange={handleChange}
                  required
                >
                  <option value="bi bi-phone">Phone (Mobile)</option>
                  <option value="bi bi-broadcast">Broadcast (DTH)</option>
                  <option value="bi bi-receipt">Receipt (Bill)</option>
                  <option value="bi bi-arrow-left-right">Transfer</option>
                  <option value="bi bi-credit-card">Credit Card</option>
                  <option value="bi bi-wallet2">Wallet</option>
                  <option value="bi bi-cash-stack">Cash</option>
                  <option value="bi bi-qr-code">QR Code</option>
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Service Status</Form.Label>
                <Form.Select
                  name="serviceStatus"
                  value={formData.serviceStatus}
                  onChange={handleChange}
                >
                  <option value="Active">Active</option>
                  <option value="Inactive">Inactive</option>
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>On/Off Screen</Form.Label>
                <Form.Select
                  name="onOffScreen"
                  value={formData.onOffScreen}
                  onChange={handleChange}
                >
                  <option value="On">On</option>
                  <option value="Off">Off</option>
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Priority <span className="text-danger">*</span></Form.Label>
                <Form.Control
                  type="number"
                  name="priority"
                  value={formData.priority}
                  onChange={handleChange}
                  min="1"
                  required
                />
              </Form.Group>
            </Col>
          </Row>

          <div className="d-flex justify-content-end gap-2 mt-4">
            <Button 
              variant="secondary" 
              onClick={handleClose}
              className="btn-outline-danger-custom"
            >
              Cancel
            </Button>
            <Button 
              type="submit"
              className="btn-outline-primary-custom"
            >
              {mode === 'add' ? 'Add Service' : 'Update Service'}
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default ServicesModal;

